import { render, staticRenderFns } from "./aOffersTable.vue?vue&type=template&id=3191435c&scoped=true"
import script from "./aOffersTable.vue?vue&type=script&lang=js"
export * from "./aOffersTable.vue?vue&type=script&lang=js"
import style0 from "./aOffersTable.vue?vue&type=style&index=0&id=3191435c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3191435c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VVirtualScroll})
